import React from "react"
import Nav from "../../Components/Patient/Nav/Nav";
import PatientRegisterForm from "../../Components/Patient/PatientRegister/PatientRegisterForm";

function Register() {
    return (
        <div>
            <Nav/>
            <PatientRegisterForm/>
        </div>
    );

}

export default Register